(ns app.front.view.pdf-markup.embedpdf
  "The single place that requires the @embedpdf npm packages.

   The CLJS test builds cannot compile these packages (the Closure
   compiler chokes on their import.meta usage), so :karma-test and :test
   alias this namespace to app.front.view.pdf-markup.embedpdf-stub in
   shadow-cljs.edn. Keep the stub's vars in sync when adding vars here;
   no build configuration changes are needed for new @embedpdf packages."
  (:require ["@embedpdf/engine" :as engine]
            ["@embedpdf/plugin-annotation" :as plugin-annotation]
            ["@embedpdf/plugin-interaction" :as plugin-interaction]
            ["@embedpdf/plugin-render" :as plugin-render]
            ["@embedpdf/plugin-selection" :as plugin-selection]
            ["@embedpdf/plugin-stage" :as plugin-stage]
            ["@embedpdf/react/annotation" :as react-annotation]
            ["@embedpdf/react/interaction" :as react-interaction]
            ["@embedpdf/react/render" :as react-render]
            ["@embedpdf/react/runtime" :as react-runtime]
            ["@embedpdf/react/selection" :as react-selection]
            ["@embedpdf/react/stage" :as react-stage]))

;; engine
(def localEngine engine/localEngine)

;; plugins
(def annotationPlugin plugin-annotation/annotationPlugin)
(def refKey engine/annotationKey)
(def interactionPlugin plugin-interaction/interactionPlugin)
(def renderPlugin plugin-render/renderPlugin)
(def selectionPlugin plugin-selection/selectionPlugin)
(def stagePlugin plugin-stage/stagePlugin)

;; react components
(def AnnotationLayer react-annotation/AnnotationLayer)
(def AnnotationMenu react-annotation/AnnotationMenu)
(def AnnotationDraftMenu react-annotation/AnnotationDraftMenu)
(def DocumentGate react-runtime/DocumentGate)
(def RenderLayer react-render/RenderLayer)
(def SelectionLayer react-selection/SelectionLayer)
(def Stage react-stage/Stage)
(def Viewer react-runtime/Viewer)

;; react hooks
(def useAnnotation react-annotation/useAnnotation)
(def useAnnotationState react-annotation/useAnnotationState)
(def useAnnotationProperties react-annotation/useAnnotationProperties)
(def useDocuments react-runtime/useDocuments)
(def useInteraction react-interaction/useInteraction)
(def useInteractionState react-interaction/useInteractionState)
(def useStage react-stage/useStage)
(def useStageState react-stage/useStageState)
